import { Directive, effect, ElementRef, inject, input } from '@angular/core';
import type { BorderType } from '@appTypes';

/* Directiva para darle a un elemento los estilos de una card */

type CardPaddings = {
  padding?: string | 0;
  paddingTop?: string | 0;
  paddingRight?: string | 0;
  paddingBottom?: string | 0;
  paddingLeft?: string | 0;
};

export type CardInputValue = CardPaddings | boolean | '' | undefined;

@Directive({
  selector: '[appCard]',
  standalone: true,
})
export class Card {
  // Dependencias
  private elementRef = inject(ElementRef);

  // Inputs
  $value = input.required<CardInputValue>({ alias: 'appCard' } );
  $border = input.required<BorderType>({ alias: 'dirBorder' });
  $shadow = input<boolean>(true, { alias: 'cardShadow' });
  $overflowHidden = input<boolean>(true, { alias: 'cardOverflowHidden' });

  // Signals / atributos
  defaultPaddingTop: string = '15px';
  defaultPaddingRight: string = '20px';
  defaultPaddingBottom: string = '15px';
  defaultPaddingLeft: string = '20px';
  defaultPadding: string = `15px 20px`;

  constructor() {
    effect(() => {
      const element = this.elementRef.nativeElement as HTMLElement;
      let value = this.$value();

      // Limpiar clases previas
      element.classList.remove('card');
      element.classList.remove('card--shaded');
      element.classList.remove('border-tiny');
      element.classList.remove('border-small');
      element.classList.remove('border-medium');
      element.classList.remove('border-large');
      element.classList.remove('overflow-hidden');
      if (value === false)
        return;

      // Aplicar border radius
      if (this.$border() !== 'none')
        element.classList.add(`border-${ this.$border() }`);

      // Aplicar overflow: hidden
      if (this.$overflowHidden())
        element.classList.add('overflow-hidden');

      // Aplicar clases de la card
      element.classList.add(!this.$shadow() ? 'card' : 'card--shaded');

      if (value === undefined || value === '' || value === true)
        value = {};

      // Aplicar paddings
      element.style.padding = value.padding?.toString() ?? this.defaultPadding;

      if (value.paddingTop !== undefined)
        element.style.paddingTop = value.paddingTop.toString();

      if (value.paddingRight !== undefined)
        element.style.paddingRight = value.paddingRight.toString();

      if (value.paddingBottom !== undefined)
        element.style.paddingBottom = value.paddingBottom.toString();

      if (value.paddingLeft !== undefined)
        element.style.paddingLeft = value.paddingLeft.toString();
    });
  }
}
